module.exports = __webpack_public_path__ + "img/export.7c3fc57f.svg";